import type { BuilderType } from '@shared/utils/api/configs/rtkBaseQueryDemo';
import { SUBMIT_PUBLIC_MEDREFILL_REQUEST_URL } from '@shared/utils/api/configs/URL';
import { hasCcdpSuccess } from '@shared/utils/api/handlers/interpretCcdpCode/interpretCcdpCode';
import type { GenericApiResponse } from '@shared/utils/api/types';

import type { SubmitMedRefillResult, SubmitPublicMedRefillRequestPayload } from '../types/submitMedRefillRequest';

export const submitPublicMedRefillRequest = <T extends BuilderType>(builder: T) =>
  builder.mutation<SubmitMedRefillResult, SubmitPublicMedRefillRequestPayload>({
    query: (params) => ({
      data: params,
      method: 'POST',
      url: SUBMIT_PUBLIC_MEDREFILL_REQUEST_URL,
    }),
    transformResponse: (response: GenericApiResponse<SubmitMedRefillResult>) => {
      if (hasCcdpSuccess(response)) {
        return response.Result;
      }
      throw {
        code: response.Code,
        message: response.Message,
      };
    },
  });
